import React, { useState, useEffect } from 'react';
import Upload from "~/Components/Upload/Upload";
import { humanFileSize } from '~/helpers/utils';
import { ProgressBar } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import produce from "immer";
import deleteIcon from "~/assets/icons/delete.png";
import { connect } from "react-redux";
import { toast } from 'react-toastify';

const AdminValidationFileUploader = ({ event, onUploaded }) => {

    const [fileToUpload, setFileToUpload] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [uploading, setUploading] = useState(false);

    const addFiles = (files) => {
        setFileToUpload(files[0]);
    }

    const removeFile = () => {
        setError('');
        setFileToUpload(null);
    }

    const fileUploaded = (file) => {

        const newList = produce(uploadedFiles, (draft) => {
            draft.push(file);
        });

        setUploadedFiles(newList);
    };

    const cancel = () => {
        setUploading(false);
        setFileToUpload(null);
        setError('');
    }

    const startUpload = () => {

        setUploading(true);

        let formData = new FormData();
        formData.append("file", fileToUpload);

        const onUploadProgress = (event) => {
            let newProgress = Math.round((100 * event.loaded) / event.total);
            setProgress(Math.max(newProgress, progress));
        }

        adminHttp.post("/events/" + event.id + "/validations/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
        })
        .then((res) => {
            if (onUploaded) {
                onUploaded(res.data);
            }

            cancel();

            if (res.data.status === "validation_error") {
                toast.error('File successfully uploaded, but there are some issues with data.');
            }

            if (res.data.status === "validation_ok") {
                toast.success('Success! File has no errors.');
            }
        })
        .catch(err =>{
            setProgress(0);
            setUploading(false);
            setError(err.response?.data);
            toast.error('Something went wrong!');
        })
    }

    return (
        <div className="row">
            <div className="col-12">
                <Upload maxFiles={1} accept="csv, xls, xlsx" acceptMimes="text/csv,application/vnd.ms-excel,text/x-csv,application/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    sendFiles={(files) => addFiles(files)} />
            </div>

            {fileToUpload && (
                <>
                    <div className="col-12">
                        {!error && uploading && <ProgressBar now={progress} />}

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error.message || 'Failed to upload file!'}
                            </div>
                        )}

                        <AdminValidationUploadingFile
                            onDone={(guest) => fileUploaded(file, guest)}
                            onRemove={() => removeFile()}
                            errors={error?.errors || []}
                            file={fileToUpload} />

                    </div>
                    <div className="col-12">
                        <button className="btn btn-primary mr-3"
                            onClick={() => startUpload()}>Upload and Validate</button>

                        <a className="btn btn-secondary" onClick={(e) => cancel()}>Cancel</a>
                    </div>
                </>
            )}
        </div>
    );
}

const AdminValidationUploadingFile = ({ file, onDone, errors = [], onRemove, ...props }) => {

    return (
        <>
            <div className="row">
                <div className="col-10">{file.name} ({humanFileSize(file.size)})</div>
                <div className="col-2">
                    <a className="btn" onClick={() => onRemove()}><img src={deleteIcon} /></a>
                </div>
            </div>
            {errors.length > 0 && (
                <div className="row">
                    <div className="col-12">
                        <small className="text-danger">{errors}</small>
                    </div>
                </div>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminValidationFileUploader);
